import * as $ from 'jquery';

export default class CollapsableGroup {
	public $wrapperEl: JQuery = $('.collapsableGroup');
	private triggerSelector: string = '.item__heading';
	private targetSelector: string = '.item__content';

	private setupEventHandlers(): void {
		this.$wrapperEl.on('click', this.triggerSelector, function(event:any){
			event.preventDefault();
			const element: HTMLElement = event.currentTarget as HTMLElement;

			$(element).toggleClass('target');
			$(element).siblings().slideToggle();
		});
	}
	constructor() {
		if (!this.$wrapperEl) {
			return;
		}
		this.setupEventHandlers();
		this.$wrapperEl.addClass('ready');
		this.$wrapperEl.find(this.targetSelector).slideUp(0);
	}
}
